import { render, staticRenderFns } from "./KTextField.vue?vue&type=template&id=3b209328"
import script from "./KTextField.vue?vue&type=script&lang=js"
export * from "./KTextField.vue?vue&type=script&lang=js"
import style0 from "./KTextField.vue?vue&type=style&index=0&id=3b209328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
